import script from "./LeaderProjectFormStep9.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectFormStep9.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectFormStep9.vue?vue&type=style&index=0&id=172ac08c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-172ac08c"]])

export default __exports__